/* eslint-disable class-methods-use-this */
import alt from 'src/stores/alt/alt';

import UIActions from 'src/stores/alt/actions/UIActions';
import UserActions from 'src/stores/alt/actions/UserActions';
import LoadingActions from 'src/stores/alt/actions/LoadingActions';

import { rootStore } from 'src/stores/mobx/RootStore';
import UIFetcher from 'src/fetchers/UIFetcher';
import SamplesFetcher from 'src/fetchers/SamplesFetcher';
import ComponentsFetcher from 'src/fetchers/ComponentsFetcher';
import MoleculesFetcher from 'src/fetchers/MoleculesFetcher';
import ReactionsFetcher from 'src/fetchers/ReactionsFetcher';
import WellplatesFetcher from 'src/fetchers/WellplatesFetcher';
import CellLinesFetcher from 'src/fetchers/CellLinesFetcher';
import VesselsFetcher from 'src/fetchers/VesselsFetcher';
import CollectionsFetcher from 'src/fetchers/CollectionsFetcher';
import UserLabelsFetcher from 'src/fetchers/UserLabelsFetcher';
import ScreensFetcher from 'src/fetchers/ScreensFetcher';
import ResearchPlansFetcher from 'src/fetchers/ResearchPlansFetcher';
import SearchFetcher from 'src/fetchers/SearchFetcher';
import DeviceFetcher from 'src/fetchers/DeviceFetcher';
import ContainerFetcher from 'src/fetchers/ContainerFetcher';
import GenericElsFetcher from 'src/fetchers/GenericElsFetcher';
import PrivateNoteFetcher from 'src/fetchers/PrivateNoteFetcher'
import MetadataFetcher from 'src/fetchers/MetadataFetcher';
import DeviceDescriptionFetcher from 'src/fetchers/DeviceDescriptionFetcher';
import SequenceBasedMacromoleculeSamplesFetcher from 'src/fetchers/SequenceBasedMacromoleculeSamplesFetcher';

import GenericEl from 'src/models/GenericEl';
import Sample from 'src/models/Sample';
import Component from 'src/models/Component';
import Reaction from 'src/models/Reaction';
import Wellplate from 'src/models/Wellplate';
import CellLine from 'src/models/cellLine/CellLine';
import Vessel from 'src/models/vessel/Vessel';
import Screen from 'src/models/Screen';
import ResearchPlan from 'src/models/ResearchPlan';
import DeviceDescription from 'src/models/DeviceDescription';
import Report from 'src/models/Report';
import Explorer from 'src/models/Explorer';
import Format from 'src/models/Format';
import Graph from 'src/models/Graph';
import ComputeTask from 'src/models/ComputeTask';
import LiteratureMap from 'src/models/LiteratureMap';
import Prediction from 'src/models/Prediction';
import SequenceBasedMacromoleculeSample from 'src/models/SequenceBasedMacromoleculeSample';
import ReactionSvgFetcher from 'src/fetchers/ReactionSvgFetcher';
import Metadata from 'src/models/Metadata';
import UserStore from 'src/stores/alt/stores/UserStore';
import { generateNextShortLabel } from 'src/utilities/VesselUtilities';
import { sampleAssociationLockNotification } from 'src/utilities/notificationMessages';

import _ from 'lodash';

const handleFetch = (dispatch, fetch) => {
  return fetch()
    .then((result) => {
      dispatch(result)
    })
    .catch((errorMessage) => {
      console.log(errorMessage)
    })
}

class ElementActions {
  exportElement(element, klass, exportFormat) {
    return (dispatch) => {
      GenericElsFetcher.export(element, klass, exportFormat)
        .then((result) => {
          dispatch({ element: result });
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }
  // -- Devices --
  fetchAllDevices() {
    return (dispatch) => handleFetch(dispatch, () => DeviceFetcher.fetchAll())
  }

  fetchDeviceById(deviceId) {
    return (dispatch) => handleFetch(dispatch, () => DeviceFetcher.fetchById(deviceId))
  }

  createDevice() {
    return null
  }

  changeActiveAccordionDevice(key) {
    return (dispatch) => dispatch(key)
  }

  changeSelectedDeviceId(device) {
    return (dispatch) => handleFetch(dispatch, () => DeviceFetcher.changeSelectedDevice(device))
  }

  setSelectedDeviceId(deviceId) {
    return (dispatch) => dispatch(deviceId)
  }

  setRefreshCoefficient(id, coefficient, rId) {
    const obj = { sId: id, rId, coefficient };
    return (dispatch) => dispatch({ obj });
  }

  toggleDeviceType(device, type) {
    return (dispatch) => dispatch({ device, type })
  }

  saveDevice(device) {
    if (device.isNew) {
      return (dispatch) => handleFetch(dispatch, () => DeviceFetcher.create(device))
    } else {
      return (dispatch) => handleFetch(dispatch, () => DeviceFetcher.update(device))
    }
  }

  deleteDevice(device) {
    if (!device.isNew) {
      DeviceFetcher.delete(device)
    }
    return (dispatch) => dispatch(device)
  }

  addSampleToDevice(sample, device, options) {
    return (dispatch) => dispatch({ sample, device, options })
  }

  addSampleWithAnalysisToDevice(sample, analysis, device) {
    return (dispatch) => dispatch({ sample, analysis, device })
  }

  removeSampleFromDevice(sample, device) {
    return (dispatch) => dispatch({ sample, device })
  }

  toggleTypeOfDeviceSample(device, sample, type) {
    return (dispatch) => dispatch({ device, sample, type })
  }

  changeDeviceProp(device, prop, value) {
    return (dispatch) => dispatch({ device, prop, value })
  }

  fetchDeviceAnalysisById(analysisId) {
    return (dispatch) => {
      DeviceFetcher.fetchAnalysisById(analysisId)
        .then(analysis => {
          DeviceFetcher.fetchById(analysis.deviceId)
            .then(device => {
              dispatch({ analysis, device })
            })
        })
    }
  }

  openDeviceAnalysis(device, type) {
    return (dispatch) => dispatch({ device, type })
  }

  saveDeviceAnalysis(analysis) {
    if (analysis.isNew) {
      return (dispatch) => handleFetch(dispatch, () => DeviceFetcher.createAnalysis(analysis))
    } else {
      return (dispatch) => handleFetch(dispatch, () => DeviceFetcher.updateAnalysis(analysis))
    }
  }

  createDeviceAnalysis(deviceId, analysisType) {
    return (dispatch) => {
      DeviceFetcher.fetchById(deviceId)
        .then((device) => {
          dispatch({ device, analysisType })
        })
    }
  }

  generateExperimentConfig(experiment) {
    return (dispatch) =>
      handleFetch(dispatch, () => DeviceFetcher.generateExperimentConfig(experiment))
  }

  duplicateAnalysisExperiment(analysis, experiment) {
    return (dispatch) =>
      DeviceFetcher.fetchById(analysis.deviceId)
        .then((device) => {
          dispatch({ device, analysis, experiment })
        })
  }

  changeAnalysisExperimentProp(analysis, experiment, prop, value) {
    return (dispatch) => dispatch({ analysis, experiment, prop, value })
  }

  deleteAnalysisExperiment(analysis, experiment) {
    return (dispatch) =>
      DeviceFetcher.fetchById(analysis.deviceId)
        .then((device) => {
          dispatch({ device, analysis, experiment })
        })
  }

  // -- Search --

  fetchBasedOnSearchSelectionAndCollection(params) {
    const uid = rootStore.notificationsStore.add({
      title: "Searching ...",
      level: "info",
      position: "tc",
    });
    return (dispatch) => {
      SearchFetcher.fetchBasedOnSearchSelectionAndCollection(params)
        .then((result) => {
          dispatch(result);
          rootStore.notificationsStore.removeByUid(uid);
        }).catch((errorMessage) => { console.log(errorMessage); });
    };
  }

  fetchBasedOnSearchResultIds(params) {
    const uid = rootStore.notificationsStore.add({
      title: "Searching ...",
      level: "info",
      position: "tc",
    });
    return (dispatch) => {
      SearchFetcher.fetchBasedOnSearchResultIds(params)
        .then((result) => {
          dispatch(result);
          rootStore.notificationsStore.removeByUid(uid);
        }).catch((errorMessage) => { console.log(errorMessage); });
    };
  }

  dispatchSearchResult(result) {
    return (dispatch) => {
      dispatch(result);
    }
  }

  // -- Generic --
  fetchGenericElsByCollectionId(id, queryParams = {}, elementType) {
    return (dispatch) => {
      GenericElsFetcher.fetchByCollectionId(id, queryParams)
        .then((result) => { dispatch({ result, type: elementType }); })
        .catch((errorMessage) => { console.log(errorMessage); });
    };
  }

  generateEmptyGenericEl(collectionId, type) {
    return (dispatch) => {
      GenericElsFetcher.fetchElementKlass(type)
        .then((result) => { dispatch(GenericEl.buildEmpty(collectionId, result.klass)); })
        .catch((errorMessage) => { console.log(errorMessage); });
    };
  }

  fetchGenericElById(id, type) {
    return (dispatch) => {
      GenericElsFetcher.fetchById(id)
        .then((result) => { dispatch(result); })
        .catch((errorMessage) => { console.log(errorMessage); });
    };
  }

  createGenericEl(params) {
    return (dispatch) => {
      GenericElsFetcher.create(params)
        .then((result) => { dispatch(result); })
        .catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  updateGenericEl(params, closeView = false) {
    return (dispatch) => {
      GenericElsFetcher.update(params)
        .then((result) => { dispatch({ element: result, closeView }); })
        .catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  splitElements(ui_state, name) {
    return (dispatch) => {
      GenericElsFetcher.split(ui_state, name)
        .then((result) => {
          dispatch({ ui_state: ui_state, name: name });
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  fetchSamplesByCollectionId(id, queryParams = {}, moleculeSort = false) {
    return (dispatch) => {
      SamplesFetcher.fetchByCollectionId(id, queryParams, moleculeSort)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  fetchReactionsByCollectionId(id, queryParams = {}) {
    return (dispatch) => {
      ReactionsFetcher.fetchByCollectionId(id, queryParams)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  fetchWellplatesByCollectionId(id, queryParams = {}) {
    return (dispatch) => {
      WellplatesFetcher.fetchByCollectionId(id, queryParams)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  fetchScreensByCollectionId(id, queryParams = {}) {
    return (dispatch) => {
      ScreensFetcher.fetchByCollectionId(id, queryParams)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  fetchResearchPlansByCollectionId(id, queryParams = {}) {
    return (dispatch) => {
      ResearchPlansFetcher.fetchByCollectionId(id, queryParams)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  fetchCellLinesByCollectionId(id, queryParams = {}) {
    return (dispatch) => {
      CellLinesFetcher.fetchByCollectionId(id, queryParams)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  fetchDeviceDescriptionsByCollectionId(id, queryParams = {}) {
    return (dispatch) => {
      DeviceDescriptionFetcher.fetchByCollectionId(id, queryParams)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  fetchVesselsByCollectionId(id, queryParams = {}) {
    return (dispatch) => {
      VesselsFetcher.fetchByCollectionId(id, queryParams)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  fetchSequenceBasedMacromoleculeSamplesByCollectionId(id, queryParams = {}, listOrder = 'sbmm') {
    return (dispatch) => {
      SequenceBasedMacromoleculeSamplesFetcher.fetchByCollectionId(id, queryParams, listOrder)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  // -- Samples --

  fetchSampleById(id) {
    return (dispatch) => {
      SamplesFetcher.fetchById(id)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  createSample(params, closeView = false) {
    return (dispatch) => {
      SamplesFetcher.create(params)
        .then((result) => {
          dispatch({ element: result, closeView, components: params.components })
        }).catch((errorMessage) => {
          console.log(errorMessage);
          LoadingActions.stop();
        });
    };
  }

  createSampleForReaction(sample, reaction, materialGroup) {
    return (dispatch) => {
      SamplesFetcher.create(sample)
        .then((newSample) => {
          dispatch({ newSample, reaction, materialGroup, components: sample.components })
        }).catch((errorMessage) => {
          console.log(errorMessage);
          LoadingActions.stop();
        });
    };
  }

  handleSvgReactionChange(reaction) {
    const materialsSvgPaths = {
      starting_materials: reaction.starting_materials.map((material) => material.svgPath),
      reactants: reaction.reactantsWithSbmm.map((material) => material.svgPath),
      products: reaction.products.map((material) => [material.svgPath, material.equivalent])
    };

    const solvents = reaction.solvents.map((s) => {
      const name = s.preferred_label;
      return name;
    }).filter(s => s);

    let temperature = reaction.temperature_display;
    if (/^[\-|\d]\d*\.{0,1}\d{0,2}$/.test(temperature)) {
      temperature = `${temperature} ${reaction.temperature.valueUnit}`;
    }

    return () => {
      const productsOnly = reaction.reaction_type === 'interaction';
      const showYield = !productsOnly;
      ReactionSvgFetcher.fetchByMaterialsSvgPaths(materialsSvgPaths, temperature, solvents, reaction.duration, reaction.conditions, productsOnly, showYield)
        .then((result) => {
          reaction.reaction_svg_file = result.reaction_svg;
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  editReactionSample(reactionID, sampleID) {
    return (dispatch) => {
      SamplesFetcher.fetchById(sampleID)
        .then((result) => {
          dispatch({ sample: result, reaction: reactionID });
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  updateSampleForReaction(sample, reaction, closeView = true) {
    return async (dispatch) => {
      try {
        // Save components first if it's a mixture and capture the API response so
        // newly inserted rows pick up their real DB ids on subsequent saves.
        let savedComponents = null;
        if (sample.isMixture() && sample.components) {
          savedComponents = await ComponentsFetcher.saveOrUpdateComponents(sample, sample.components);
        }

        // Update sample
        const newSample = await SamplesFetcher.update(sample);

        // Initialize components on newSample before updating material in reaction
        if (sample.isMixture() && sample.components) {
          const refreshed = Component.refreshFromApi(savedComponents, sample.components);
          newSample.initialComponents(refreshed);
        }

        // Update the material in the reaction and dispatch
        reaction.updateMaterial(newSample);
        reaction.changed = true;

        dispatch({
          reaction,
          sample: newSample,
          closeView,
        });
      } catch (errorMessage) {
        console.log(errorMessage);
        // Ensure loading stops even on error
        LoadingActions.stop();
      }
    };
  }

  updateSample(params, closeView = false) {
    return (dispatch) => {
      SamplesFetcher.update(params)
        .then((result) => {
          dispatch({ element: result, closeView, components: params.components })
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  generateEmptySample(collection_id) {
    return Sample.buildEmpty(collection_id)
  }

  tryFetchCellLineElById(cellLineId) {
    return (dispatch) => {
      CellLinesFetcher.fetchById(cellLineId)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  createCellLine(params) {
    return (dispatch) => {
      const { currentUser } = UserStore.getState();
      CellLinesFetcher.create(params, currentUser)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  generateEmptyCellLine(collectionId, template) {
    const { currentUser } = UserStore.getState();
    if (!currentUser) { return; }

    const cellLineSample = CellLine.buildEmpty(collectionId, `${currentUser.initials}-C${currentUser.cell_lines_count}`);
    if (template) {
      cellLineSample.copyMaterialFrom(template);
    }
    return cellLineSample;
  }

  copyCellLineFromId(id, collectionId) {
    return (dispatch) => {
      CellLinesFetcher.copyCellLine(id, collectionId)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  splitAsSubsamples(ui_state) {
    return (dispatch) => {
      SamplesFetcher.splitAsSubsamples(ui_state)
        .then((result) => {
          dispatch(ui_state);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  copySampleFromClipboard(collection_id) {
    return collection_id;
  }

  addSampleToMaterialGroup(params) {
    UIActions.selectTab(0);
    return params;
  }

  showReactionMaterial(params) {
    const sampleCoefficient = params.sample.coefficient;
    return (dispatch) => {
      SamplesFetcher.fetchById(params.sample.id)
        .then((result) => {
          params.coefficient = sampleCoefficient;
          params.sample = result;
          dispatch(params);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        })
    }
  }

  importSamplesFromFile(params) {
    return (dispatch) => {
      SamplesFetcher.importSamplesFromFile(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  // -- Molecules --

  fetchMoleculeByMolfile(molfile, svg_file = null) {
    return (dispatch) => {
      MoleculesFetcher.fetchByMolfile(molfile, svg_file)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  // -- Reactions --

  fetchReactionById(id) {
    return (dispatch) => {
      ReactionsFetcher.fetchById(id)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  tryFetchReactionById(id) {
    return (dispatch) => {
      ReactionsFetcher.fetchById(id)
        .then((result) => {
          dispatch(result)
        }).catch((errorMessage) => {
          console.log(errorMessage)
        })
    }
  }

  tryFetchWellplateById(id) {
    return (dispatch) => {
      WellplatesFetcher.fetchById(id)
        .then((result) => {
          dispatch(result)
        }).catch((errorMessage) => {
          console.log(errorMessage)
        })
    }
  }

  tryFetchGenericElById(id) {
    return (dispatch) => {
      GenericElsFetcher.fetchById(id)
        .then((result) => {
          dispatch(result)
        }).catch((errorMessage) => {
          console.log(errorMessage)
        })
    }
  }
  closeWarning() {
    return null
  }

  createReaction(params) {
    return (dispatch) => {
      ReactionsFetcher.create(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        }).finally(() => {
          LoadingActions.stop();
        });
    };
  }

  updateReaction(params, closeView = false) {
    return (dispatch) => {
      ReactionsFetcher.update(params)
        .then((result) => {
          dispatch({ element: result, closeView });
        }).catch((errorMessage) => {
          console.log(errorMessage);
        }).finally(() => {
          LoadingActions.stop();
        });
    };
  }

  generateEmptyReaction(collection_id) {
    return Reaction.buildEmpty(collection_id)
  }

  copyReactionFromId(id, keepAmounts = false) {
    return (dispatch) => {
      ReactionsFetcher.fetchById(id)
        .then((result) => {
          dispatch({ reaction: result, keepAmounts });
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  copyReaction(reaction, colId, keepAmounts = false) {
    return (dispatch) => {
      ReactionsFetcher.fetchById(reaction.id)
        .then((result) => {
          dispatch({ reaction: result, colId, keepAmounts });
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  copyResearchPlan(research_plan, colId) {
    return (dispatch) => {
      ResearchPlansFetcher.fetchById(research_plan.id)
        .then((result) => {
          dispatch({ research_plan: result, colId: colId });
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  copyElement(element, colId) {
    return (
      { element: element, colId: colId }
    )
  }

  openReactionDetails(reaction) {
    return reaction;
  }

  // -- Wellplates --
  splitAsSubwellplates(ui_state) {
    return (dispatch) => {
      WellplatesFetcher.splitAsSubwellplates(ui_state)
        .then((result) => {
          dispatch(ui_state);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  splitAsSubCellLines(ui_state) {
    return (dispatch) => {
      const ids = ui_state["cell_line"].checkedIds.toArray();
      const collection_id = ui_state.currentCollection.id;

      CellLinesFetcher.splitAsSubCellLines(ids, collection_id)
        .then((result) => {
          dispatch(ui_state);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  bulkCreateWellplatesFromSamples(params) {
    let { collection_id, samples, wellplateCount } = params;

    // wellplateCount correction
    if (wellplateCount > Math.ceil(samples.length / 96)) {
      wellplateCount = Math.ceil(samples.length / 96)
    }

    // build wellplate objects from samples
    let wellplates = [];
    _.range(wellplateCount).forEach((i) => {
      wellplates[i] = Wellplate.buildFromSamplesAndCollectionId(_.compact(samples.slice(96 * i, 96 * (i + 1))), collection_id).serialize();
    });

    return (dispatch) => {
      WellplatesFetcher.bulkCreateWellplates({ wellplates: wellplates })
        .then(() => {
          dispatch();
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  generateWellplateFromClipboard(collection_id) {
    return collection_id;
  }

  generateEmptyWellplate(collection_id) {
    return Wellplate.buildEmpty(collection_id);
  }

  createWellplate(wellplate) {
    return (dispatch) => {
      WellplatesFetcher.create(wellplate)
        .then(result => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  editWellplateSample(wellplateID, sampleID) {
    return (dispatch) => {
      SamplesFetcher.fetchById(sampleID)
        .then((result) => {
          dispatch({ sample: result, wellplate: wellplateID });
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  updateWellplate(wellplate) {
    return (dispatch) => {
      WellplatesFetcher.update(wellplate)
        .then(result => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  updateSampleForWellplate(sample, wellplate) {
    return (dispatch) => {
      SamplesFetcher.update(sample)
        .then((newSample) => {
          dispatch(wellplate)
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  fetchWellplateById(id) {
    return (dispatch) => {
      WellplatesFetcher.fetchById(id)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  resizeWellplate(wellplateId, width, height) {
    return (dispatch) => {
      WellplatesFetcher.resize(wellplateId, width, height)
        .then((result) => {
          if (!result.error) {
            // Stamp updated_at so WellplateDetails#componentDidUpdate adopts the
            // reconciled wellplate coming back from the server: eln_timestamp has
            // second resolution, so the server's own value can be byte-identical
            // to the one already on screen.
            result.updated_at = new Date();
            // The stamp lands after WellplatesFetcher baselined the checksum, and
            // a Date drops out of the hash where the string did not - without
            // this the freshly persisted wellplate reads as edited and locks the
            // size control it just came out of.
            result.updateChecksum();
          }
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          LoadingActions.stop();
        });
    };
  }

  importWellplateSpreadsheet(wellplateId, attachmentId) {
    return (dispatch) => {
      WellplatesFetcher.importWellplateSpreadsheet(wellplateId, attachmentId)
        .then((result) => {
          result.updated_at = new Date();
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  // -- Screens --
  addResearchPlanToScreen(screen_id, collection_id, afterComplete = () => {}) {
    return (dispatch) => {
      ScreensFetcher.addResearchPlan(screen_id, collection_id)
        .then(result => dispatch(result.screen))
        .then(() => { afterComplete(); })
        .catch(errorMessage => console.log(errorMessage));
    };
  }

  generateScreenFromClipboard(collection_id) {
    return collection_id;
  }

  fetchScreenById(id) {
    return (dispatch) => {
      ScreensFetcher.fetchById(id)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  generateEmptyScreen(collection_id) {
    return Screen.buildEmpty(collection_id);
  }

  createScreen(params) {
    return (dispatch) => {
      ScreensFetcher.create(params)
        .then(result => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  updateScreen(params) {
    return (dispatch) => {
      ScreensFetcher.update(params)
        .then(result => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  // -- ResearchPlans --

  fetchResearchPlanById(id) {
    return (dispatch) => {
      ResearchPlansFetcher.fetchById(id)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  updateCellLine(params) {
    return (dispatch) => {
      CellLinesFetcher.update(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  updateResearchPlan(params) {
    return (dispatch) => {
      ResearchPlansFetcher.update(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  updateEmbeddedResearchPlan(params) {
    return (dispatch) => { dispatch(params); };
  }

  generateEmptyResearchPlan(collection_id) {
    return ResearchPlan.buildEmpty(collection_id);
  }

  createResearchPlan(params) {
    return (dispatch) => {
      ResearchPlansFetcher.create(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  importWellplateIntoResearchPlan(researchPlanId, wellplateId, afterComplete = () => {}) {
    return (dispatch) => {
      ResearchPlansFetcher.importWellplate(researchPlanId, wellplateId)
        .then((result) => { dispatch(result); })
        .then(() => { afterComplete(); })
        .catch((errorMessage) => { console.log(errorMessage); });
    };
  }

  importTableFromSpreadsheet(researchPlanId, attachmentId, afterComplete = () => {}) {
    return (dispatch) => {
      ResearchPlansFetcher.importTableFromSpreadsheet(researchPlanId, attachmentId)
        .then((result) => { dispatch(result); })
        .then(() => { afterComplete(); })
        .catch((errorMessage) => { console.log(errorMessage); });
    };
  }

  // -- DeviceDescriptions --

  fetchDeviceDescriptionById(id) {
    return (dispatch) => {
      DeviceDescriptionFetcher.fetchById(id)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  updateDeviceDescription(params) {
    return (dispatch) => {
      DeviceDescriptionFetcher.updateDeviceDescription(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  generateEmptyDeviceDescription(collection_id) {
    return DeviceDescription.buildEmpty(collection_id);
  }

  createDeviceDescription(params) {
    return (dispatch) => {
      DeviceDescriptionFetcher.createDeviceDescription(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  copyDeviceDescriptionFromClipboard(collection_id) {
    return collection_id;
  }

  splitAsSubDeviceDescription(ui_state) {
    return (dispatch) => {
      DeviceDescriptionFetcher.splitAsSubDeviceDescription(ui_state)
        .then((result) => {
          dispatch(ui_state.ui_state);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  // -- Vessels --

  fetchVesselElById(vesselId) {
    return (dispatch) => {
      VesselsFetcher.fetchById(vesselId)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  fetchVesselTemplateById(vesselTemplateId, collectionId) {
    return (dispatch) => {
      VesselsFetcher.fetchVesselTemplateById(vesselTemplateId, collectionId)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  fetchEmptyVesselTemplate(collectionId) {
    return (dispatch) => {
      VesselsFetcher.fetchEmptyVesselTemplate(collectionId)
        .then((result) => {
          dispatch(result);
        })
        .catch((errorMessage) => {
          console.error(errorMessage);
        });
    };
  }

  createVessel(params) {
    return (dispatch) => {
      const { currentUser } = UserStore.getState();
      VesselsFetcher.createVesselInstance(params, currentUser)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  createVesselTemplate(params) {
    return (dispatch) => {
      const { currentUser } = UserStore.getState();
      VesselsFetcher.createVesselTemplate(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  generateEmptyVessel(collectionId, template) {
    const { currentUser } = UserStore.getState();
    if (!currentUser) { return; }

    const shortLabel = generateNextShortLabel();
    const vesselInstance = Vessel.buildEmpty(collectionId, shortLabel);

    if (template) {
      vesselInstance.copyMaterialFrom(template);
    }
    return vesselInstance;
  }

  generateEmptyVesselTemplate(collectionId, template) {
    if (!collectionId || isNaN(Number(collectionId))) {
      console.warn('[ElementActions] Invalid collectionId:', collectionId);
      return null;
    }
    const { currentUser } = UserStore.getState();
    if (!currentUser) { return; }

    const vesselTemplate = Vessel.buildEmpty(collectionId);
    vesselTemplate.type = 'vessel_template';
    vesselTemplate.is_new = true;

    if (template) {
      vesselTemplate.copyMaterialFrom(template);
    }

    return vesselTemplate;
  }

  updateVessel(params) {
    return (dispatch) => {
      VesselsFetcher.updateVesselInstance(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  updateVesselTemplate(params) {
    return (dispatch) => {
      VesselsFetcher.updateVesselTemplate(params)
        .then((result) => {
          dispatch(result);
        })
        .catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  // -- Sequence Based Macromolecule Samples --

  fetchSequenceBasedMacromoleculeSampleById(id) {
    return (dispatch) => {
      SequenceBasedMacromoleculeSamplesFetcher.fetchById(id)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  updateSequenceBasedMacromoleculeSample(params) {
    return (dispatch) => {
      SequenceBasedMacromoleculeSamplesFetcher.updateSequenceBasedMacromoleculeSample(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  generateEmptySequenceBasedMacromoleculeSample(collection_id) {
    return SequenceBasedMacromoleculeSample.buildEmpty(collection_id);
  }

  createSequenceBasedMacromoleculeSample(params) {
    return (dispatch) => {
      SequenceBasedMacromoleculeSamplesFetcher.createSequenceBasedMacromoleculeSample(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
          // Ensure loading stops even on error
          LoadingActions.stop();
        });
    };
  }

  copySequenceBasedMacromoleculeSampleFromClipboard(collection_id) {
    return collection_id;
  }

  splitAsSubSequenceBasedMacromoleculeSample(ui_state) {
    return (dispatch) => {
      SequenceBasedMacromoleculeSamplesFetcher.splitAsSubSequenceBasedMacromoleculeSample(ui_state)
        .then((result) => {
          dispatch(ui_state.ui_state);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  // -- DataCite/Radar metadata --

  fetchMetadata(collection_id) {
    return (dispatch) => {
      return MetadataFetcher.fetch(collection_id)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  storeMetadata(metadata) {
    return (dispatch) => {
      return MetadataFetcher.store(metadata)
        .then((result) => {
          dispatch(result);
          return result;
        }).catch((error) => {
          // The spinner is stopped by LoadingStore listening for this action's dispatch, which
          // does not happen on failure — and the rejection has to reach handleSave, or the tab
          // clears its dirty flag and the user believes a refused save succeeded.
          LoadingActions.stop();
          throw error;
        });
    };
  }

  // -- Report --
  showReportDetails() {
    return Report.buildEmpty()
  }

  showFormatContainer() {
    return Format.buildEmpty();
  }

  showComputedPropsGraph() {
    return Graph.buildEmptyScatter();
  }

  showComputedPropsTasks() {
    return ComputeTask.buildEmpty();
  }

  showLiteratureDetail() {
    return LiteratureMap.buildEmpty();
  }

  // -- Explorer --
  showExplorerDetails() {
    return Explorer.buildEmpty();
  }

  // -- Prediction --
  showPredictionContainer() {
    return Prediction.buildEmpty();
  }

  // -- General --

  refreshElements(type) {
    return type;
  }

  deleteElements(options) {
    return (dispatch) => {
      dispatch(options);
      UIActions.uncheckWholeSelection();
      UserActions.fetchCurrentUser();
    }
  }

  removeElements() {
    return;
  }

  // Current Element
  setCurrentElement(newCurrentElement) {
    return newCurrentElement;
  }

  deselectCurrentElement() {
    return null;
  }

  // - ...
  deleteElementsByUIState(params) {
    return (dispatch) => {
      UIFetcher.deleteElementsByUIState(params)
        .then((result) => {
          if (result && result.locked_sample_ids && result.locked_sample_ids.length > 0) {
            rootStore.notificationsStore.add(
              sampleAssociationLockNotification(result.locked_sample_ids.length)
            );
          }
          dispatch(result);
        })
        .catch((errorMessage) => { console.log(errorMessage); });
    };
  }

  bulkUpdateUserLabels(params) {
    return (dispatch) => {
      UserLabelsFetcher.bulkUpdate(params)
        .then(() => {
          rootStore.notificationsStore.add({
            title: 'Bulk edit user labels',
            message: 'Labels updated for the selection.',
            level: 'success',
            position: 'tr',
            autoDismiss: 5,
            uid: 'bulkUpdateUserLabels',
          });
          dispatch();
        })
        .catch(() => {
          rootStore.notificationsStore.add({
            title: 'Bulk edit user labels',
            message: 'Could not update labels for the selection.',
            level: 'error',
            position: 'tr',
            autoDismiss: 5,
            uid: 'bulkUpdateUserLabels',
          });
        });
    };
  }

  changeSorting(sort) {
    return sort;
  }

  changeSbmmSampleOrder(order) {
    return order;
  }

  changeElementsFilter(filter) {
    return filter;
  }

  updateContainerContent(params) {
    return (dispatch) => {
      ContainerFetcher.updateContainerContent(params)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  computePropsFromSmiles(sampleId) {
    return (dispatch) => {
      MoleculesFetcher.computePropsFromSmiles(sampleId)
        .then((result) => {
          dispatch(result);
        }).catch((errorMessage) => {
          console.log(errorMessage);
        });
    };
  }

  refreshComputedProp(cprop) {
    return cprop;
  }

  refreshElementsAfterCollectionChanges(collectionId) {
    return collectionId;
  }

  // -- Private Note --
  createPrivateNote(params) {
    return (dispatch) => {
      PrivateNoteFetcher.create(params).then((result) => {
        dispatch(result)
      }).catch((errorMessage) => {
        console.log(errorMessage);
      })
    };
  }

  updatePrivateNote(note) {
    return (dispatch) => {
      PrivateNoteFetcher.update(note).then((result) => {
        dispatch(result)
      }).catch((errorMessage) => {
        console.log(errorMessage);
      })
    };
  }
}

export default alt.createActions(ElementActions);
